import React, {Component} from "react";
import {connect} from "react-redux";
import {Loading} from "../components/components";
import {BottomNavigation, BottomNavigationAction, Box, IconButton, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Add, Remove} from "@mui/icons-material";
import {decrementExposure, getExposureName, incrementExposure} from "../utils/exposure_utils";
import {isNull} from "../../../utils/utils";

class ExposureControl extends Component {

	constructor(props) {
		super(props);

		this.state = this.initState();
	}

	initState = () => {
		return {};
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.slide !== this.props.slide)
			this.setState(this.initState());
	}

	getExposureControlComponent = () =>
		this.state.open ?
			<Box sx={{
				height: '20vh', width: '4.3vw', border: '0px', bgcolor: "rgba(51, 4, 112,0.8)",
				display: "flex", overflowY: 'scroll',
			}}>
				<Stack direction="column" justifyContent={"space-around"} width={"100%"}>
					<IconButton color={"secondary"}>
						<Typography sx={{fontSize: '0.8vw', height: '3vh',}}>Exposure</Typography>
					</IconButton>
					<IconButton
						color={"secondary"}
						onClick={() => incrementExposure(this.props.slide, this.props.exposure)}
						disabled={false}
						sx={{height: '6vh'}}
					>
						<Add fontSize="large"/>
					</IconButton>
					<IconButton
						color={"secondary"}
						onClick={() => decrementExposure(this.props.slide, this.props.exposure)}
						disabled={false}
						sx={{height: '6vh'}}
					><Remove fontSize="large"/>
					</IconButton>
				</Stack>
			</Box> : null;

	render() {
		if (!this.props.slide)
			return <Loading/>;

		if (!this.props.slide?.meta?.exposure_stack)
			return null;

		if (isNull(this.props.exposure))
			incrementExposure(this.props.slide);

		return <Stack direction={"column-reverse"} alignItems={"flex-end"}>
			<BottomNavigation sx={{borderRadius: 0, bgcolor: "rgba(51, 4, 112,0.8)", width: "4.3vw"}}
			                  onChange={() => this.setState({open: !this.state.open,})}>
				<BottomNavigationAction icon={<Typography variant={'h5'} align={"center"} gutterBottom={true}
				                                          color={this.state.open ? "secondary" : "white"}>
					{getExposureName(this.props.slide, this.props.exposure)}
				</Typography>}/>
			</BottomNavigation>
			{this.getExposureControlComponent()}
		</Stack>
	}
}

const mapStateToProps = (state) => {
	let activeMapId = state.gammaStateReducer.activeMapId;
    let {exposure, slide} = state.mapsStateReducer[activeMapId] ?? {};
	return {activeMapId, exposure, slide};
}

export default connect(mapStateToProps)(ExposureControl);
